import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../api';
import './Login.css'; // Reuse login styles for consistency

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setMessage('No verification token provided. Please check your email link.');
        return;
      }

      try {
        const data = await authAPI.verifyEmail(token);
        
        // Store token and user info
        localStorage.setItem('token', data.token);
        if (data.refresh_token) localStorage.setItem('refresh_token', data.refresh_token);
        localStorage.setItem('user', JSON.stringify(data.user));

        setStatus('success');
        setMessage('Email verified! Redirecting to dashboard...');
        
        // Redirect to dashboard after 2 seconds
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } catch (err) {
        setStatus('error');
        setMessage(err.message || 'Verification failed. Please try again or request a new link.');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="login-container">
      <div className="login-box" style={{ textAlign: 'center', minHeight: '300px' }}>
        <div className="login-header">
          <h1>Trckle</h1>
          <p>Email Verification</p>
        </div>

        <div style={{ padding: '40px 20px' }}>
          {status === 'verifying' && (
            <>
              <div style={{
                width: '50px',
                height: '50px',
                border: '4px solid #4feb7b',
                borderTop: '4px solid transparent',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 20px'
              }}></div>
              <p>{message}</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>✓</div>
              <p style={{ color: '#4feb7b', fontSize: '1.1rem' }}>{message}</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>✗</div>
              <p style={{ color: '#ff6969', marginBottom: '20px' }}>{message}</p>
              <button
                onClick={() => navigate('/login')}
                style={{
                  padding: '10px 20px',
                  background: '#4feb7b',
                  color: '#000',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: 'bold'
                }}
              >
                Back to Login
              </button>
            </>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default VerifyEmail;
